module.exports = __webpack_public_path__ + "assets/img/structure-6b0419e5.png";